import {z} from 'zod'
import {PHONE_REGEX} from '../helpers/validation.helper'
import {ELang, ERole} from '../types/user.type'
import {createPaginatedResponse} from './app.schemas'

export const NetworkRoleSchema = z.object({
  networkId: z.string().min(1),
  role: z.enum([ERole.VIEWER, ERole.REQUESTOR, ERole.OPC]),
})

export const UserSchema = z.object({
  id: z.string(),
  email: z.string(),
  password: z.string().optional(),
  firstName: z.string(),
  lastName: z.string(),
  phone: z.string().optional(),
  lang: z.enum(ELang).optional(),
  isAdmin: z.boolean(),
  banned: z.boolean().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  networkRoles: z.array(NetworkRoleSchema).optional(),
  // True once the user has set their password (completed onboarding).
  hasPassword: z.boolean().optional(),
})

export const UsersPaginated = createPaginatedResponse(UserSchema)

// Aggregated per-client user counts (billing indicator). Each user is counted
// once under their highest network role, so role buckets may sum to less than
// `total` (users with no active role still count toward `total`).
export const ClientUserStatsSchema = z.object({
  total: z.number(),
  roles: z.object({
    OPC: z.number(),
    REQUESTOR: z.number(),
    VIEWER: z.number(),
  }),
  activation: z.object({
    activated: z.number(),
    pending: z.number(),
  }),
})

// Form schema for creating user
export const InviteUserFormSchema = z.object({
  email: z.email().toLowerCase(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  phone: z.string().regex(PHONE_REGEX).or(z.literal('')).optional(),
})

// Full create user schema (for API payload)
export const InviteUserSchema = InviteUserFormSchema.extend({
  clientId: z.string().min(1),
  networkRoles: z.array(NetworkRoleSchema).min(1),
})

// Form schema for updating user
export const UpdateUserFormSchema = z.object({
  firstName: z.string().min(1).optional(),
  lastName: z.string().min(1).optional(),
  phone: z.string().regex(PHONE_REGEX).or(z.literal('')).optional(),
})

// Full update user schema (for API payload)
export const UpdateUserSchema = UpdateUserFormSchema.extend({
  clientId: z.string().min(1),
  networkRoles: z.array(NetworkRoleSchema).optional(),
})
